// removed by extract-text-webpack-plugin
module.exports = {"nf-procurements-history__grid":"nf-procurements-history__grid","rt-table":"rt-table","rt-resizable-header-content":"rt-resizable-header-content","rt-td":"rt-td"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/ProcurementHistoryGrid/ProcurementHistoryGrid.scss
// module id = 4959
// module chunks = 1